//import "./mega_menu";
//import "./accordion"; // footer accordion?
//import "./tooltip";
//import "./stacked-table";
//import "./carousel-buttons";
import Chatlink from "./chatlink"; // live chat
import initMuCardPods from "./muCardPod"; // card pods
import initMuAccordion from "./muAccordion"; // list accordion
import initMuCarousel from "./muCarousel"; // homepage carousel
//import MuSearchDesktop from "./MuSearchDesktop";
//import MuSearchMobile from "./MuSearchMobile";
//import suggestions from "./search-suggestion";

let chatlink = new Chatlink();
// muCarousel();
// MuSearchDesktop();
// MuSearchMobile();

document.addEventListener("DOMContentLoaded", () => {
    initMuCardPods();
    initMuCarousel();
    initMuAccordion();
});
